module.exports = __webpack_public_path__ + "static/media/icon_dental.6b157e85.svg";